import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAuthData } from '../features/authSlice';
import Loader from '../components/Live/Loader';
import { setAuthCookies } from '../utils/cookieUtils';

const Redirect = () => {
    const dispatch = useDispatch();
    const location = useLocation(); // Get the current location
    const navigate = useNavigate(); // Hook to navigate programmatically

    useEffect(() => {
        const params = new URLSearchParams(location.search); // Parse the query string
        const encodedData = params.get("data"); // Extract the 'data' parameter

        if (encodedData) {
            try {
                const decodedData = decodeURIComponent(encodedData); // Decode the parameter
                const parsedData = JSON.parse(decodedData); // Parse it into a JavaScript object

                const authResponse = {
                    status: 200,
                    errorCode: 0,
                    data: parsedData,
                };

                // Dispatch action to set authentication data
                dispatch(setAuthData(authResponse));

                // Store in secure cookies
                try {
                    setAuthCookies(authResponse);
                } catch (cookieError) {
                    console.error('Failed to store in cookies:', cookieError);
                    // Continue with login even if cookie storage fails
                }

                // Remove the 'data' parameter from the URL
                params.delete("data");
                setTimeout(() => {
                  navigate("/dashboard/home");
                }, 200);
            } catch (error) {
                console.error("Error decoding or parsing the data parameter:", error);
            }
        }
    }, [dispatch, location.search, navigate]);

    return (
        <div>
            <Loader />
        </div>
    )
}

export default Redirect
